import Cookies from 'js-cookie';

export enum EWebViewActions {
  CLOSE_WEB_VIEW = 'close_webview',
  UPDATE_APPBAR = 'update_appbar',
}

export interface IAppBarConfig {
  background_color?: string;
  back_button_color?: string;
  is_appbar_transparent?: boolean;
  ignoreSafeArea?: boolean;
  status_icon_brightness?: string;
}

export interface IWebViewActionData {
  action: EWebViewActions;
  action_value: IAppBarConfig | { url?: string } | null;
}

export function UseWebviewCallback(
  data: IWebViewActionData,
  nativeWebFunc: () => void,
  getRes?: (res: any) => void
) {
  try {
    const isWebView = Boolean(Cookies.get('webview'));

    if (isWebView && data?.action) {
      if (
        typeof window !== 'undefined' &&
        (window as any)?.flutter_inappwebview?.callHandler
      ) {
        (window as any)
          .flutter_inappwebview.callHandler('WebViewConnect', JSON.stringify(data))
          .then((res: any) => {
            getRes?.(res);
          })
          .catch(() => {
            nativeWebFunc();
          });
        return;
      }
    }

    nativeWebFunc();
  } catch (e) {
    nativeWebFunc();
  }
}


export const closeWebView = (fallback: () => void) => {
  UseWebviewCallback(
    {
      action: EWebViewActions.CLOSE_WEB_VIEW,
      action_value: null,
    },
    fallback
  );
};

export const updateAppBar = (config: IAppBarConfig) => {
  UseWebviewCallback(
    {
      action: EWebViewActions.UPDATE_APPBAR,
      action_value: config,
    },
    () => {}
  );
};
